import { render, staticRenderFns } from "./no-data.vue?vue&type=template&id=43da25db&scoped=true"
import script from "./no-data.vue?vue&type=script&lang=ts"
export * from "./no-data.vue?vue&type=script&lang=ts"
import style0 from "./no-data.vue?vue&type=style&index=0&id=43da25db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43da25db",
  null
  
)

export default component.exports